export const ActivityOverlay = () => {
  return (
    <div
      className={`activity_overlay_container templates_modal_inner animate-up`}
    >
      <div className="activity_overlay">
        <div className="activity_overlay_inner">
          <h3>Activities temporarily hidden</h3>
          <p className="activity_overlay_inner_content">
            You will gain access within 24 hours once our team has completed the
            professor validation process.
          </p>

          <p className="activity_overlay_inner_content">
            Some of the activities are actively used in a classroom, so this
            measure prevents non professors from viewing and sharing the answers
            of these activities.
          </p>
        </div>
      </div>
    </div>
  );
};
